import { AudioData } from "./AudioData";
import * as Tone from "tone";
import { ToneAudioBuffer } from "tone";
import { isClassOf } from "../../tools/TypeUtilities";

export class FloatArrayAudioData extends AudioData
{
  #channels:Float32Array[] = [];
  #numFrames:number = 0;
  get numChannels(){ return this.#channels.length; }
  get numFrames(){ return this.#numFrames };

  toToneAudioBuffer()
  {
    return ToneAudioBuffer.fromArray( this.#channels );
  }

  set( channel:number, frame:number, sample:number)
  {
    if ( frame < 0 || frame >= this.#numFrames )
    {
      return;
    }

    this.#channels[ channel ][ frame ] = sample; 
  }

  get( channel:number, frame:number ):number
  {
    if ( frame < 0 || frame >= this.#numFrames )
    {
      return 0;
    }

    return this.#channels[ channel ][ frame ];
  }

  static create( channels:number, frames:number )
  {
    let ad = new FloatArrayAudioData();    
    ad.#numFrames = frames;
    
    for ( let i = 0; i < channels; i++ )
    {
      let channelData = new Float32Array( frames );
      ad.#channels.push( channelData );
    }

    return ad;
  }

  add( other:AudioData )
  {
    let channels = this.numChannels;
    let frames   = this.numFrames;    
    
    for ( let c = 0; c < channels; c ++ )
    {
      let otherChannel = c % other.numChannels;

      for ( let i = 0; i < frames; i++ )
      {
        let t = this.get( c, i );
        let a = other.get( otherChannel, i );

        this.set( c, i, t + a );
      }
    }
    
  } 

  static sum( data:AudioData[] ):AudioData
  {
    let length = 0; 
    let channels = 0;

    data.forEach( 
      d => 
      {
        length = Math.max( length, d.numFrames ); 
        channels = Math.max( channels, d.numChannels );
      }
    );


    let sum = FloatArrayAudioData.create( channels, length );

    for ( let i = 0; i < data.length; i++ )
    {
      sum.add( data[ i ] );
    }

    return sum;
  
  }

  static cast( data:AudioData ):FloatArrayAudioData
  {
    if ( isClassOf( data, FloatArrayAudioData ) )
    { 
      return data as FloatArrayAudioData;
    }

    let floatArrayCopy = FloatArrayAudioData.create( data.numChannels, data.numFrames );
    
    data.copyTo( floatArrayCopy );

    return floatArrayCopy;

  }
    
}